var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialYamapC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19554 2C5.5637 1.99997 4.94604 2.18725 4.42062 2.53819C3.89521 2.88912 3.48562 3.38793 3.24363 3.97159C3.00165 4.55525 2.93813 5.19756 3.06111 5.81731C3.18409 6.43706 3.48804 7.00645 3.93454 7.45349C4.51133 8.03028 5.87542 8.8695 5.95329 9.76063C5.95329 9.82411 5.97851 9.885 6.0234 9.92989C6.06829 9.97478 6.12917 10 6.19265 10C6.25613 10 6.31702 9.97478 6.36191 9.92989C6.4068 9.885 6.43202 9.82411 6.43202 9.76063C6.51277 8.88103 7.87398 8.03028 8.45077 7.45349C8.89851 7.00716 9.20365 6.43795 9.32752 5.818C9.45138 5.19804 9.38839 4.55527 9.14653 3.97115C8.90467 3.38704 8.49482 2.88789 7.96895 2.53697C7.44308 2.18605 6.82486 1.99916 6.19265 2H6.19554ZM6.19565 6.31433C6.41696 6.31433 6.6333 6.24871 6.81731 6.12576C7.00132 6.0028 7.14474 5.82805 7.22944 5.62359C7.31413 5.41912 7.33629 5.19414 7.29311 4.97708C7.24994 4.76002 7.14337 4.56064 6.98688 4.40415C6.83039 4.24766 6.63101 4.14109 6.41395 4.09791C6.19689 4.05474 5.97191 4.07689 5.76744 4.16158C5.56298 4.24627 5.38822 4.3897 5.26527 4.57371C5.14231 4.75772 5.07669 4.97405 5.07669 5.19536C5.07669 5.49213 5.19458 5.77675 5.40443 5.98659C5.61427 6.19644 5.89888 6.31433 6.19565 6.31433Z",
    fill: "#FF4433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYamapC);
export default __webpack_public_path__ + "static/media/social_yamap_c.6a94e7365993341efcdca10b92e4ecde.svg";
export { ForwardRef as ReactComponent };